export const MAP_STATE = 'MAP';
export const MAP_INFO_WINDOW_ID = 'map-info-window';
